function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "Cloud Functions for Firebase (7- Raw Icon, Light)");

var _ref3 = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.");

var _ref4 = /*#__PURE__*/React.createElement("g", {
  id: "Page-1",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("g", {
  id: "Cloud-Functions-for-Firebase-(7--Raw-Icon,-Light)",
  transform: "translate(-8.000000, -14.000000)"
}, React.createElement("polygon", {
  id: "Path",
  points: "0 0 192 0 192 192 0 192"
}), React.createElement("path", {
  d: "M160.056,134.048 L160.056,57.968 L133.112,31.024 L150.064,14.064 L184,48 L184,134.16 L183.944,134.192 L183.944,144.024 L150.04,177.936 L133.112,161 L160.056,134.048 Z M31.944,134.024 L58.888,160.976 L41.936,177.936 L8,144 L8,57.84 L8.056,57.808 L8.056,47.976 L41.96,14.064 L58.888,31 L31.944,57.952 L31.944,134.032 L31.944,134.024 Z M60.008,108.024 C53.361,108.024 47.972,102.635 47.972,95.988 C47.972,89.341 53.361,83.952 60.008,83.952 C66.653,83.952 72.04,89.339 72.04,95.984 C72.04,102.629 66.653,108.016 60.008,108.016 L60.008,108.024 Z M95.992,108.024 C89.345,108.024 83.956,102.635 83.956,95.988 C83.956,89.341 89.345,83.952 95.992,83.952 C102.637,83.952 108.024,89.339 108.024,95.984 C108.024,102.629 102.637,108.016 95.992,108.016 L95.992,108.024 Z M131.976,108.024 C125.329,108.024 119.94,102.635 119.94,95.988 C119.94,89.341 125.329,83.952 131.976,83.952 C138.621,83.952 144.008,89.339 144.008,95.984 C144.008,102.629 138.621,108.016 131.976,108.016 L131.976,108.024 Z",
  id: "Shape",
  fill: "#FFFFFF"
})));

var SvgCloudFunctions = function SvgCloudFunctions(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: "176px",
    height: "164px",
    viewBox: "0 0 176 164",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? React.createElement("title", null, title) : null, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgCloudFunctions, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/cloud-functions.118814e6.svg";
export { ForwardRef as ReactComponent };